import { EdiClearingHouseReducer } from "./EdiClearingHouseReducer";
import { EDIReportReducer } from "./EDIReportReducer";

const EdiClearingHouseReducers = {
  ediClearingHouse: EdiClearingHouseReducer,
  ediReport: EDIReportReducer,
};
export default EdiClearingHouseReducers;